var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyActionitemsactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Action_items_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12346",
    transform: "translate(17533.27 12098)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_662_00000106842580332604484910000011358829430328044428_",
    className: "st0",
    cx: -17510.3,
    cy: -12075,
    rx: 10.1,
    ry: 10.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17510.3-12063.5c-6.3,0-11.5-5.2-11.5-11.5c0-6.3,5.2-11.5,11.5-11.5s11.5,5.2,11.5,11.5 C-17498.8-12068.7-17503.9-12063.5-17510.3-12063.5z M-17510.3-12083.6c-4.8,0-8.6,3.9-8.6,8.6c0,4.8,3.9,8.6,8.6,8.6 s8.6-3.9,8.6-8.6C-17501.6-12079.8-17505.5-12083.6-17510.3-12083.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-17511.6-12071.4c-0.4,0-0.7-0.1-1-0.4l-2-2.1c-0.6-0.6-0.5-1.5,0-2c0.6-0.5,1.5-0.5,2,0l1.1,1.1l4.1-3.6 c0.6-0.5,1.5-0.5,2,0.1c0.5,0.6,0.5,1.5-0.1,2l-5.1,4.5C-17511-12071.5-17511.3-12071.4-17511.6-12071.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12347",
    transform: "translate(17550.164 11998.439)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17504.6-11973.5h-5.6c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4h5.6c0.8,0,1.4,0.6,1.4,1.4 S-17503.8-11973.5-17504.6-11973.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17511.7-11980.6c-0.5,0-1-0.3-1.3-0.8c-0.4-0.7-0.1-1.6,0.6-1.9l3.2-1.6c0.7-0.4,1.6-0.1,1.9,0.6 c0.4,0.7,0.1,1.6-0.6,1.9l-3.2,1.6C-17511.2-11980.7-17511.4-11980.6-17511.7-11980.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17508.4-11964.7c-0.2,0-0.4,0-0.6-0.2l-3.2-1.6c-0.7-0.4-1-1.2-0.6-1.9c0.4-0.7,1.2-1,1.9-0.6l3.2,1.6 c0.7,0.4,1,1.2,0.6,1.9C-17507.4-11965-17507.9-11964.7-17508.4-11964.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12348",
    transform: "translate(0 1.314)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,23.7H0.4C-0.4,23.7-1,23-1,22.2s0.6-1.4,1.4-1.4h5.6c0.8,0,1.4,0.6,1.4,1.4S6.8,23.7,6.1,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,16.5c-0.2,0-0.4,0-0.6-0.2l-3.2-1.6c-0.7-0.4-1-1.2-0.6-1.9c0.4-0.7,1.2-1,1.9-0.6l3.2,1.6 c0.7,0.4,1,1.2,0.6,1.9C8.5,16.2,8,16.5,7.5,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.3,32.4c-0.5,0-1-0.3-1.3-0.8c-0.4-0.7-0.1-1.6,0.6-1.9l3.2-1.6c0.7-0.3,1.6-0.1,1.9,0.6 c0.4,0.7,0.1,1.6-0.6,1.9l-3.2,1.6C4.7,32.3,4.5,32.4,4.3,32.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyActionitemsactive);
export default __webpack_public_path__ + "static/media/My Action items active.c3b97d487b831492fc5cd9a23ff6df9a.svg";
export { ForwardRef as ReactComponent };